export class RefundStatusLookupRoute {
    static accessed: boolean;
}
